import React from 'react';
import PropTypes from 'prop-types';
import "./MultiSeriesChart.css";

export default function MultiSeriesSVGContainer({childComponentConfigs, width, height,id, children }) {
  return (
    <svg className="ReactD3MultiSeriesChartSVG" style={(childComponentConfigs!=null && childComponentConfigs.length>0)? {overflow:'visible',zIndex:1}:{}} id={id} width={width} height={height}>
      {
        children
      }
    </svg>
  )
}

